module.exports = __webpack_public_path__ + "static/media/5-2.68d51243.mp3";